import dayjs from "dayjs";

/**
 * Gets the repective field errors
 * @returns {string} The error helper message
 */
export const validateForm = (
  categoryId,
  title,
  abstract,
  message,
  author,
  source,
  newsImage,
  recipientsData,
  expiry,
  schedule,
  scheduleDate,
  myNewsArticle,
  scheduleTime
) => {
  const errors = {};
  const today = dayjs().startOf("day");
  const currentTime = dayjs().startOf("minute");

  if (categoryId === undefined || categoryId === null) {
    errors.categoryId = "Category is required";
  }
  if (!title || title.trim() === "") {
    errors.title = "Title is required.";
  }

  if (!abstract || abstract.trim() === "") {
    errors.title = "Abstract content is required.";
  }
  const isEmpty = message.blocks.every((block) => !block.text.trim());

  if (isEmpty) {
    errors.message = "Message content is required.";
  }

  if (!author || author.trim() === "") {
    errors.author = "Author name is required.";
  }
  if (!source || source.trim() === "") {
    errors.source = "Source details are required.";
  }
  if (!newsImage || newsImage.trim() === "" || newsImage === null) {
    errors.newsImage = "Image/Thumbnail is required.";
  }
  if (recipientsData.length === 0) {
    errors.recipientsData = "At least one recipient is required";
  }
  if (!expiry) {
    errors.expiryDate = "Expiry date is required";
  } else if (
    dayjs(expiry, "DD-MM-YYYY").isBefore(dayjs(today, "DD-MM-YYYY"), "day")
  ) {
    errors.expiryDate = "Expiry date must be in the future";
  }

  if (schedule) {
    if (!scheduleDate && myNewsArticle) {
      errors.scheduleDate = "Schedule date is required";
    } else {
      let scheduleDate2 = dayjs(scheduleDate, "DD-MM-YYYY");
      if (scheduleDate2.isBefore(today)) {
        errors.scheduleDate = "Schedule date must be in the future";
      } else if (scheduleDate2.isSame(today, "day") && scheduleTime) {
        let scheduleTime2 = dayjs(scheduleTime, "HH:mm");
        if (scheduleTime2.isBefore(currentTime)) {
          errors.scheduleTime = "Schedule time must be in the future";
        }
      }
    }
    if (!scheduleTime && myNewsArticle) {
      errors.scheduleTime = "Schedule time is required";
    }
  }

  return errors;
};
/**
 * Gets the repective field errors for draft form
 * @returns {string} The error helper message
 */
export const draftValidation = (title, categoryId, recipientsFlag, expiry) => {
  const errors = {};
  const today = dayjs().startOf("day");

  if (!title || title.trim() === "") {
    errors.title = "Title is required.";
  }
  if (categoryId === undefined || categoryId === null) {
    errors.categoryId = "Category is required";
  }
  if (!recipientsFlag) {
    errors.recipientsFlag = "Atleast one recipient is required";
  }
  if (dayjs(expiry, "DD-MM-YYYY").isBefore(dayjs(today, "DD-MM-YYYY"), "day")) {
    errors.expiryDate = "Expiry date must be in the future";
  }

  return errors;
};

 /**
 * Converts a Base64-encoded image string into a Blob object.
 *
 * @param {Date} base64 - The Base64-encoded image string.
 * @returns {string} A Blob object representing the image have size and type.
 */
 export const base64ToBlob = (base64) => {
  const base64WithoutPrefix = base64.replace(
    /^data:image\/(\w+);base64,/,
    ""
  );
  const mime = /^data:image\/(\w+);base64,/.exec(base64)[1];
  const bytes = atob(base64WithoutPrefix);
  const array = new Uint8Array(bytes.length);
  for (let index = 0; index < bytes.length; index++) {
    array[index] = bytes.charCodeAt(index);
  }
  return new Blob([array], { type: `image/${mime}` });
};